import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class Layout extends React.Component {
  static propTypes = {
    direction: PropTypes.string,
    align: PropTypes.string,
    fallbackToRowAt: PropTypes.string,
    children: PropTypes.node,
  };

  render() {
    const { direction, align, fallbackToRowAt, children } = this.props;

    const styles = {
      wrapper: classnames({
        'layout-wrapper': true,
      }),
      layout: classnames({
        layout: true,
        'layout--column': direction === 'column',
        'layout--row': direction === 'row',
        'layout--align-center': align === 'center',
        'layout--row-medium-screens': fallbackToRowAt === 'medium-screens',
        'layout--row-wide-screens': fallbackToRowAt === 'wide-screens',
      }),
    };

    return (
      <div className={styles.wrapper}>
        <div className={styles.layout}>
          {children}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Layout/Layout.jsx
 **/